import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { API_URL } from "../../config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    Vue.axios.defaults.headers.common["Content-type"] = "application/json";
  },

  setBaseUrl(url) {
    Vue.axios.defaults.baseURL = url;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },

  getAll(resource) {
    return Vue.axios.get(`${resource}`).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },

  get(resource) {
    return Vue.axios.get(`${resource}`).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },

  post(resource, params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`${resource}`, params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          let message = "Unknown error";
          if (error.response.status === 400) {
            if (error.response.data.length > 0)
              message = error.response.data[0];
          }
          reject(message);
        });
    });
  },

  update(resource, params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`${resource}`, params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          let message = "Unknown error";
          if (error.response.status === 400) {
            if (error.response.data.length > 0)
              message = error.response.data[0];
          }
          reject(message);
        });
    });
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(` ApiService ${error}`);
    });
  }
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/http/axios/index.js